import React, { useState } from 'react';
import styled from 'styled-components';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const WalkieTalkie = styled.div`
  background: #2b2b2b;
  border-radius: 30px;
  padding: 20px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.3);
  position: relative;
  overflow: hidden;
`;

const Antenna = styled.div`
  width: 8px;
  height: 60px;
  background: #1a1a1a;
  position: absolute;
  top: -30px;
  right: 40px;
  border-radius: 4px;
  transform: rotate(-15deg);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    background: #ff4d00;
    border-radius: 4px;
  }
`;

const Screen = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 15px;
  margin: 10px 0;
  color: #ff4d00;
  font-family: 'Courier New', monospace;
  min-height: 100px;
  position: relative;
  overflow: hidden;
`;

const LED = styled.div`
  width: 10px;
  height: 10px;
  background: ${props => props.active ? '#ff4d00' : '#4d1500'};
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 15px;
  box-shadow: 0 0 10px ${props => props.active ? '#ff4d00' : 'transparent'};
`;

const StyledAudioPlayer = styled(AudioPlayer)`
  background: #1a1a1a !important;
  border-radius: 15px;
  box-shadow: none !important;

  .rhap_main-controls-button {
    color: #ff4d00 !important;
  }

  .rhap_progress-filled {
    background-color: #ff4d00 !important;
  }

  .rhap_progress-indicator {
    background: #ff4d00 !important;
  }

  .rhap_time {
    color: #ff4d00 !important;
  }

  .rhap_volume-button {
    color: #ff4d00 !important;
  }

  .rhap_volume-bar {
    background: #333 !important;
  }

  .rhap_volume-indicator {
    background: #ff4d00 !important;
  }
`;

const StationSelect = styled.select`
  background: #1a1a1a;
  color: #ff4d00;
  border: 2px solid #ff4d00;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  margin-bottom: 10px;
  font-family: 'Courier New', monospace;
  cursor: pointer;
  outline: none;

  &:focus {
    box-shadow: 0 0 10px rgba(255, 77, 0, 0.3);
  }

  option {
    background: #1a1a1a;
    color: #ff4d00;
  }
`;

const Scanner = () => {
  const [currentStation, setCurrentStation] = useState({
    name: 'LA City Fire Department',
    url: 'https://broadcastify.cdnstream1.com/11878'
  });

  const stations = [
    { name: 'LA City Fire Department', url: 'https://broadcastify.cdnstream1.com/11878' },
    { name: 'LA County Fire - Dispatch', url: 'https://broadcastify.cdnstream1.com/25757' }
  ];

  const handleStationChange = (event) => {
    const station = stations.find(s => s.name === event.target.value);
    if (station) {
      setCurrentStation(station);
    }
  };

  return (
    <WalkieTalkie>
      <Antenna />
      <Screen>
        <LED active={true} />
        <StationSelect value={currentStation.name} onChange={handleStationChange}>
          {stations.map(station => (
            <option key={station.name} value={station.name}>
              {station.name}
            </option>
          ))}
        </StationSelect>
        <StyledAudioPlayer
          src={currentStation.url}
          autoPlay={false}
          showJumpControls={false}
          customControlsSection={['MAIN_CONTROLS', 'VOLUME_CONTROLS']}
          header={currentStation.name}
          onError={(e) => console.log('Audio Error:', e)}
        />
      </Screen>
    </WalkieTalkie>
  );
};

export default Scanner;
